import {Http} from './http.init'
import {ResponseWrapper, ErrorWrapper} from './util'

const ENTITY = 'users'

export function getById (user_id) {
  return new Promise((resolve, reject) => {
    return new Http({auth: true}).get(`${ENTITY}/${user_id}`)
      .then(response => {
        resolve(new ResponseWrapper(response, response.data.data))
      })
      .catch(error => {
        let message = error.response.data ? error.response.data.error : error.response.statusText
        reject(new ErrorWrapper(error, message))
      })
  })
}

export function update (id, data) {
  return new Promise((resolve, reject) => {
    new Http({auth: true}).patch(`${ENTITY}/${id}`, data)
      .then(response => resolve(new ResponseWrapper(response, response.data.data)))
      .catch(error => reject(new ErrorWrapper(error)))
  })
}

export function changePassword (data) {
  if (!data.oldPassword || !data.newPassword) throw new Error('required oldPassword and newPassword params')

  return new Promise((resolve, reject) => {
    new Http({auth: true}).post(`${ENTITY}/change-password`, data)
      .then(response => resolve(new ResponseWrapper(response, response.data.data)))
      .catch(error => reject(new ErrorWrapper(error)))
  })
}

export function getCurrent () {
  return new Promise((resolve, reject) => {
    return new Http({auth: true}).get(`${ENTITY}/current`)
      .then(response => {
        resolve(new ResponseWrapper(response, response.data.data))
      })
      .catch(error => {
        let message = error.response.data ? error.response.data.error : error.response.statusText
        reject(new ErrorWrapper(error, message))
      })
  })
}

export function getPostsByUserId (user_id) {
  return new Promise((resolve, reject) => {
    new Http({auth: true}).get(`${ENTITY}/${user_id}/posts`)
      .then(response => {
        let data = {
          content: response.data.data,
          total: response.data.data.total ? response.data.data.total : ''
        }
        resolve(new ResponseWrapper(response, data))
      })
      .catch(error => {
        let message = error.response.data ? error.response.data.error : error.response.statusText
        reject(new ErrorWrapper(error, message))
      })
  })
}



// WEBPACK FOOTER //
// ./src/services/user.service.js